import React, { useState } from 'react';
import { Tabs, Card, Row, Col, Typography } from 'antd';
import { ShoppingOutlined, FolderOutlined, PartitionOutlined, InboxOutlined } from '@ant-design/icons';
import Products from './products';
import Categories from './category';
import SubCategories from './subcategory';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const ProductsCatalogHub = ({ defaultTab = '1' }) => {
    const [activeTab, setActiveTab] = useState(defaultTab);

    return (
        <div style={{ padding: '4px' }}>
            {/* Header Banner */}
            <div className="welcome-banner-card" style={{ marginBottom: '24px' }}>
                <Row justify="space-between" align="middle" gutter={[16, 16]}>
                    <Col xs={24} md={18}>
                        <Title level={2} className="welcome-title" style={{ margin: 0, fontWeight: '800', letterSpacing: '-0.5px' }}>
                            Products & Catalog Hub
                        </Title>
                        <Text className="welcome-subtitle" style={{ fontSize: '15px', display: 'block', marginTop: '6px' }}>
                            Manage your system inventory items, category hierarchies, and product classifications in one place.
                        </Text>
                    </Col>
                    <Col xs={24} md={6} className="welcome-time-col">
                        <div className="welcome-time-container">
                            <InboxOutlined style={{ marginRight: '8px' }} />
                            <span>Inventory Master</span>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* Main Tabs Container */}
            <Card className="dashboard-card" bordered={false} bodyStyle={{ padding: '24px' }}>
                <Tabs activeKey={activeTab} onChange={setActiveTab} size="large" centered>
                    <TabPane 
                        tab={
                            <span>
                                <ShoppingOutlined style={{ marginRight: 8 }} />
                                Products
                            </span>
                        } 
                        key="1"
                    >
                        <div style={{ marginTop: '16px' }}>
                            <Products />
                        </div>
                    </TabPane>
                    
                    <TabPane 
                        tab={
                            <span>
                                <FolderOutlined style={{ marginRight: 8 }} />
                                Categories
                            </span>
                        } 
                        key="2"
                    >
                        <div style={{ marginTop: '16px' }}>
                            <Categories />
                        </div>
                    </TabPane>

                    <TabPane 
                        tab={
                            <span>
                                <PartitionOutlined style={{ marginRight: 8 }} />
                                Sub-Categories
                            </span>
                        } 
                        key="3"
                    >
                        <div style={{ marginTop: '16px' }}>
                            <SubCategories />
                        </div>
                    </TabPane>
                </Tabs>
            </Card>
        </div>
    );
};

// Route wrapper components to maintain state integrity without re-mounting
export const ProductsTabWrapper = () => <ProductsCatalogHub defaultTab="1" />;
export const CategoriesTabWrapper = () => <ProductsCatalogHub defaultTab="2" />;
export const SubCategoriesTabWrapper = () => <ProductsCatalogHub defaultTab="3" />;

export default ProductsCatalogHub;
